import { render, staticRenderFns } from "./PropertyGallery.html?vue&type=template&id=22b01915&"
import script from "./PropertyGallery.ts?vue&type=script&lang=ts&"
export * from "./PropertyGallery.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_gallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports